import {
	Component,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	ViewChildren,
	ElementRef,
	QueryList,
	AfterViewInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { IAbstractView } from '@core/interfaces';
import { Address, Store as StoreModel } from '@core/models';
import { ButtonComponent, IconComponent, InputComponent } from '@shared/components';
import { AdressesLocatorPresenter } from './adresses-locator.presenter';
import { IAdressesLocatorComponent, IAdressesLocatorPresenter } from './interfaces';
import { AdressesLocatorModeEnum } from './enums';

@Component({
	selector: 'app-adresses-locator',
	templateUrl: './adresses-locator.component.html',
	styleUrls: ['./adresses-locator.component.scss'],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, IconComponent, InputComponent, ButtonComponent],
	providers: [AdressesLocatorPresenter],
	standalone: true,
})
export class AdressesLocatorComponent
	extends IAbstractView<IAdressesLocatorPresenter>
	implements IAdressesLocatorComponent, AfterViewInit
{
	@Input() mode: AdressesLocatorModeEnum = AdressesLocatorModeEnum.Full;
	@Input() storeInDelivery?: StoreModel[] | null = null;

	readonly AdressesLocatorModeEnum = AdressesLocatorModeEnum;

	@Input() set IsModal(value: boolean) {
		this.presenter.IsModal = value;
	}
	get IsModal(): boolean {
		return this.presenter.IsModal;
	}

	@Input() set isModal(value: boolean) {
		this.presenter.IsModal = value;
	}

	@Output() addressSelected = new EventEmitter<string>();
	@Output() deliveryConfirmed = new EventEmitter<void>();

	auth$ = this.presenter.auth$;
	orderType$ = this.presenter.orderType$;
	address$ = this.presenter.address$;
	autocompleteResults$ = this.presenter.autocompleteResults$;
	clientLocation$ = this.presenter.clientLocation$;
	isLoading$ = this.presenter.isLoading$;
	formGroup = this.presenter.formGroup;
	translations = this.presenter.translations;
	errorMessages = this.presenter.errorMessages;
	isLoggedIn = this.presenter.isLoggedIn;
	isPickup = this.presenter.isPickup;
	showNameAddressInput = this.presenter.showNameAddressInput;
	isAddressAvailable$ = this.presenter.addressAvailable();

	get searchAddressInput(): string {
		return this.presenter.searchAddressInput ?? '';
	}
	set searchAddressInput(value: string | null) {
		this.presenter.searchAddressInput = value ?? '';
	}

	get idAddressDefault(): string | null {
		return this.presenter.idAddressDefault;
	}
	set idAddressDefault(value: string | null) {
		this.presenter.idAddressDefault = value;
	}

	@ViewChild('locationInput', { read: ElementRef, static: false })
	locationInput?: ElementRef<HTMLInputElement>;

	@ViewChildren('locationInput', { read: ElementRef })
	locationInputs?: QueryList<ElementRef<HTMLInputElement>>;

	constructor(presenter: AdressesLocatorPresenter) {
		super(presenter);
	}

	findUserLocation(): void {
		this.presenter.findUserLocation();
	}

	saveManualAddress(inputOrString?: HTMLInputElement | string | null): void {
		this.presenter.saveManualAddress(inputOrString);
		const address = typeof inputOrString === 'string' ? inputOrString : inputOrString?.value;
		if (address) {
			this.addressSelected.emit(address);
		}
	}

	selectAutocomplete(result: google.maps.places.AutocompletePrediction): void {
		this.presenter.selectAutocomplete(result, this.locationInput);
		this.addressSelected.emit(result.description);
	}

	onAddressInputChange(event: Event | string): void {
		this.presenter.onAddressInputChange(event, window);
	}

	onApartmentOrSuiteChange(event: Event | string): void {
		this.presenter.onApartmentOrSuiteChange(event);
	}

	onDeliveryInstructionsChange(event: Event | string): void {
		this.presenter.onDeliveryInstructionsChange(event);
	}

	onFavoriteChange(event: Event | boolean): void {
		this.presenter.onFavoriteChange(event);
	}

	onAddressClick(address: Address): void {
		this.presenter.onAddressClick(address);
		const addressString = `${address.direccion1}${address.direccion2 ? ', ' + address.direccion2 : ''}`;
		this.addressSelected.emit(addressString);
	}

	updateDeliveryAddress(event: Event): void {
		this.presenter.updateDeliveryAddress(event);
	}

	confirmDeliveryAddress(): void {
		this.presenter.confirmDeliveryAddress();
		this.deliveryConfirmed.emit();
	}

	addressAvailable(): Observable<boolean> {
		return this.presenter.addressAvailable();
	}

	onInputBlur(): void {
		setTimeout(() => {
			this.clearAutocomplete();
		}, 200);
		this.saveManualAddress(this.searchAddressInput);
	}

	clearAutocomplete(): void {
		this.presenter.clearAutocomplete();
	}
}
